export default function () {
  return {
    item: {},
    items: [],
    pagination: {},
    total: 0
  }
}
